import React from 'react';
import Dashboard from '../../components/admin/Dashboard';

const DashboardPage = () => {
  return (
    <div className="p-6">
      <Dashboard />
    </div>
  );
};

export default DashboardPage;